import Phaser from "phaser";
import {generateGameConfig} from "./config";
import {KitchenScene} from "./scene";
import {LobbyScene} from "./lobby_scene";
import {initClerkAuth, isSignedIn, mountSignIn, addListener} from "./auth";

declare global {
    interface Window { kitchenGame: Phaser.Game }
}

const BETA_MODE = new URLSearchParams(window.location.search).has('beta');

export let KITCHEN_SERVER_CONFIG: Phaser.Types.Core.GameConfig = generateGameConfig(Phaser.AUTO, [LobbyScene, KitchenScene]);

export const createKitchenGame = () => new KitchenGame(KITCHEN_SERVER_CONFIG);

class KitchenGame extends Phaser.Game {
    get kitchenScene(): KitchenScene { return this.scene.scenes[0] as KitchenScene }
    get localCook() { return  this.kitchenScene.localCookSprite.instance}
}

function showBetaError(phase: string, error: unknown): void {
    if (!BETA_MODE) return;
    const overlay = document.getElementById('clerk-overlay') as HTMLElement;
    overlay.innerHTML = '';
    const box = document.createElement('div');
    box.style.cssText = 'color:#fff;font-family:monospace;padding:2em;max-width:600px;text-align:left;';
    box.innerHTML = `
        <h2 style="color:#ff6b6b;">[BETA] Bootstrap failed</h2>
        <p><strong>Phase:</strong> ${phase}</p>
        <pre style="white-space:pre-wrap;color:#ffa;">${error instanceof Error ? error.stack || error.message : String(error)}</pre>
        <p style="color:#888;margin-top:1em;">Add ?beta to URL to see this diagnostic. Remove to hide.</p>
    `;
    overlay.appendChild(box);
}

async function bootstrap() {
    try {
        await initClerkAuth();
    } catch (err) {
        console.error('[hotplate] Clerk auth init failed:', err);
        showBetaError('initClerkAuth', err);
        return;
    }

    const overlay = document.getElementById('clerk-overlay') as HTMLElement;
    const signinContainer = document.getElementById('clerk-signin') as HTMLElement;

    if (!isSignedIn()) {
        try {
            mountSignIn(signinContainer as HTMLDivElement);
        } catch (err) {
            console.error('[hotplate] mountSignIn failed:', err);
            showBetaError('mountSignIn', err);
            return;
        }
        addListener((resources: any) => {
            if (resources.session) {
                overlay.classList.add('hidden');
                const game = createKitchenGame();
                window.kitchenGame = game;
            }
        });
        return;
    }

    overlay.classList.add('hidden');

    const game = createKitchenGame();
    window.kitchenGame = game;
}

bootstrap();
